module.exports = __webpack_public_path__ + "images/apple-touch-icon-76x76.7d2b0046647d52718c1e626652e9337f.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-76x76.png
// module id = 996
// module chunks = 0